import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperShoppingBagPage } from './shopper-shopping-bag';

@NgModule({
  declarations: [
    ShopperShoppingBagPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperShoppingBagPage),
    TranslateModule.forChild()
  ],
})
export class ShopperShoppingBagPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-shopping-bag/shopper-shopping-bag.module.ts